export default __webpack_public_path__ + "static/toolPanel-1bc0f7001a179af6a5480a7d6983b806.gif";